import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import api from "../lib/api";

export function ContextoFarmacia({ user }) {
  const [est, setEst] = useState(null);
  useEffect(() => {
    api.get("/studies").then((r) => setEst((r.data || [])[0] || null)).catch(() => {});
  }, []);
  const farmacia = user?.pharmacy_name || user?.name;
  if (!farmacia && !est) return null;
  return (
    <div className="hidden xl:flex items-center gap-2 text-xs text-slate-500 shrink-0 max-w-md" data-testid="contexto-farmacia">
      <Building2 size={14} className="text-slate-400 shrink-0" />
      <span className="font-semibold text-slate-700 truncate">{farmacia}</span>
      {est && (
        <Link to={`/studies/${est.id}`} className="truncate hover:text-slate-800" title="Estudio con el que se calculan los datos de stock" data-testid="contexto-estudio">
          · Estudio «{est.name}» · {est.period_days} días
        </Link>
      )}
    </div>
  );
}
